import React from "react";
import CancelButton from "@/components/atomics/cancel-button";

interface HeaderProps {
  title: string;
  className?: string;
  onCancelClick?: () => void;
}

const GuideHeader = ({ title, className, onCancelClick }: HeaderProps) => {
  return (
    <div
      className={`flex items-center justify-between px-[21px] py-[5px] bg-primary-blue ${className}`}
    >
      <h1 className="text-white text-[33px] font-silkscreen ">{title}</h1>
      <CancelButton onClick={onCancelClick} />
    </div>
  );
};

export default GuideHeader;
